import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@mui/material";
import { Box } from "@mui/system";
import { dateTimeFormat } from "constants/componentsConstants";
import dayjs from "configs/dayjs.config";

import { getAlertColor } from "pages/Dashboards/ProjectViewer/util/util";
import { useEffect, useState } from "react";
import { TaskMeta } from "./TaskMeta";
import TaskPreviewModal from "./TaskPreviewModal";

export const ProjectProductTaskMeta = ({ row }) => {
  const [criticalTextColor, setCriticalTextColorTextColor] = useState("");
  useEffect(() => {
    setCriticalTextColorTextColor(
      getAlertColor(row.partLotDeadline, row.expectedEndDate, row.taskToOn)
    );
  }, []);
  return (
    <TableContainer content={Box}>
      <TaskPreviewModal
        task={{
          title: row.docCode,
          docDetails: row.docDetails,
          detail: row.taskDetails,
          description: row.taskDescription,
          taskByName: row.taskBy,
          taskToName: row.taskTo,
          taskToOn: row.taskToOn,
          acceptanceStatus: row.acceptanceStatus,
          acceptanceComment: row.acceptanceComment,
          acceptanceOn: row.acceptanceOn,
          deadline: row.deadline,
          doneStatus: row.doneStatus,
          doneOn: row.doneOn,
          acknowledgeStatus: row.acknowledgeStatus,
          acknowledgeOn: row.acknowledgeOn,
        }}
      >
        <Table
          size="small"
          sx={{
            "& .MuiTableCell-root": {
              borderBottom: "none",
              color: criticalTextColor,
            },
          }}
        >
          <TableBody>
            <TableRow>
              <TableCell>
                {row.docCode} - {row.productName}
              </TableCell>
              <TableCell align="right">
                Qty - {row.partLotQuantity} / {row.productQuantity}
                {row.productUom}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell colSpan={2}>
                <TaskMeta
                  acceptanceOn={row.acceptanceOn}
                  acceptanceStatus={row.acceptanceStatus}
                  deadline={row.deadline}
                  doneOn={row.doneOn}
                  doneStatus={row.doneStatus}
                  taskByName={row.taskBy}
                  taskDetails={row.taskDetails}
                  taskToName={row.taskTo}
                  taskToOn={row.taskToOn}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                {row.expectedEndDate
                  ? `Estd. End Date - ${dayjs(row.expectedEndDate).format(
                      dateTimeFormat.date
                    )}`
                  : "-"}
              </TableCell>
              <TableCell align="right">
                {row.partLotDeadline
                  ? `Product DL - ${dayjs(row.partLotDeadline).format(
                      dateTimeFormat.date
                    )}`
                  : "-"}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TaskPreviewModal>
    </TableContainer>
  );
};
